import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Header: React.FC = () => {
  const { t } = useLanguage();

  const handleScroll = (e: React.MouseEvent<HTMLElement>, targetId: string) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header id="home" className="header">
      <div className="hero">
        <h1>{t('header.title')}</h1>
        <p>{t('header.subtitle')}</p>
        <button 
          className="cta-button" 
          onClick={(e) => handleScroll(e, 'contact')}
        >
          {t('header.cta')}
        </button>
      </div>
    </header>
  );
};

export default Header; 